import React, { useCallback, useState } from 'react'

export const useToggle = (
  initialState: boolean
): [boolean, () => void, React.Dispatch<React.SetStateAction<boolean>>] => {
  const [isOpen, setIsOpen] = useState(initialState)

  const toggleIsOpen = useCallback(() => {
    setIsOpen(state => !state)
  }, [])

  return [isOpen, toggleIsOpen, setIsOpen]
}
